export enum APP_DEFAULTS {
  minFraction = 2,
  maxFraction = 2,
  VATPerc = 15,
  ComCommPerc = 0.15,
  Currency = `&#xE900;`,
}

export const APP_LISTS = {
  VATValues: [
    {
      label: "0%",
      value: 0,
    },
    {
      label: "15%",
      value: 15,
    },
  ],
};
